module.exports = __webpack_public_path__ + "static/media/feature-split-image-03.4c0536a8.png";